const apiUrl = "https://aus-worker.onrender.com";
export default apiUrl;
